<template>
  <div class="wrapper box_v">
    <div class="header-wrapper">
      <div class="iconfont icon-fanhui2" @click="$router.go(-1)"></div>
      <div class="header">商品详情</div>
      <Button class="bkcc-btn" @click="showHexiao">核销</Button>
    </div>
    <div class="content box_f1 box" style="padding: 0 20px 30px">
      <!--左侧商品详情卡片-->
      <Card class="detail-card">
        <div slot="title" class="box card-title">
          <div>商品信息</div>
          <Button type="primary" @click="$router.push({name: 'newExchange', query: {id}});">编辑</Button>
        </div>
        <div v-if="!_.isEmpty(good)" class="box_v" style="height: 100%">
          <img class="cover" :src="good.cover"/>
          <div class="box_f1 detail-info box_v ">
            <!--商品标题-->
            <div class="detail-title">{{good.title}}</div>
            <!--商品积分数量-->
            <div class="detail-num">
              <span class="num-title">积分</span>
              <span style="margin-right: 50px">{{good.score}}</span>
              <span class="num-title">商品数量</span>
              <span>{{good.num}}</span>
            </div>
            <!--商品领取时间-->
            <div class="detail-time">
              <i class="iconfont icon-time"></i>
              <span>领取时间：</span>
              <span>{{good.startDate}}</span>
              <span style="margin: 0 15px">至</span>
              <span>{{good.endDate}}</span>
            </div>
            <!--商品领取地点-->
            <div class="detail-address">
              <i class="iconfont icon-didian"></i>
              <span>领取地点：{{good.address}}</span>
            </div>
            <!--商品二维码-->
            <div class="codeBox">
              <div class="cobox" @mouseover="imgHover()" @mouseout="imgOut()"
                   :style="good.qrcode.length > 1? 'margin-left: 20px;display: inline-block':''"
                   v-for="(item, index) in good.qrcode" :key="index">
                <Spin fix v-show="isLoading"></Spin>
                <div class="shadow pointer" v-show="isShowShadow && (!isLoading)" @click="reloadImg">
                  <span class="iconfont icon-zhongzhi icon"></span>
                  <span>重新加载</span>
                </div>
                <img v-if="!isImgFail" :src="item.url" @error="noImg()">
                <div v-if="isImgFail && (!isLoading)" class="imgerror box pointer" @click="reloadImg">
                  <span class="iconfont icon-zhongzhi icon"></span>
                  <span>重新加载</span>
                </div>
              </div>
            </div>
            <!--下载按钮-->
            <div class="detail-btn">
              <Button @click="downLoad(0)" :loading="download0">下载二维码</Button>
              <Button type="primary" @click="downLoad(1)" :loading="download1">下载海报</Button>
            </div>
          </div>
        </div>
      </Card>
      <!--右侧兑换统计-->
      <Card class="exchange-card">
        <div slot="title" class="box card-title">
          <div>兑换统计</div>
          <div>
            <Button @click="showBulu">补录</Button>
            <Button type="primary" @click="exportPeople">导出</Button>
          </div>
        </div>
        <div style="position: relative;height: 100%">
          <Table border :columns="columns" :data="exchangeData" style="width: 100%" @on-sort-change="tableChange"></Table>
          <div class="page-wrapper">
            <Page v-if="showPage" :total="total" :page-size="rows" show-total @on-change="pageChange"/>
          </div>
        </div>
      </Card>
    </div>
    <select-people title="核销" :searchList="hexiaoPeople" :btnLoading="false" ref="hexiaoModal" :btn-list="hexiaoBtn"
                   @searchPeople="searchHexiao" @submit="hexiaoSubmit">
      <div slot="triangle" slot-scope="scope">
        <div class="triangle"></div>
        <div class="triangle-info">已兑换</div>
      </div>
    </select-people>
    <select-people title="补录" :searchList="buluPeople" :btnLoading="false" ref="buluModal" :btn-list="buluBtn"
                   @searchPeople="searchBulu" @submit="buluSubmit"></select-people>
  </div>
</template>

<script>
  import selectPeople from '../../../components/selectPeople'

  var that
  var statusC = ''
  export default {
    name: 'goodDetail',
    components: {
      selectPeople
    },
    data() {
      return {
        id: '',
        good: {},
        isShowShadow: false,
        isLoading: false,
        qrcode: [],
        isImgFail: false,
        columns: [{
          title: '姓名',
          key: 'name',
        }, {
          title: '兑换状态',
          key: 'status',
          sortable: 'custom',
          // filters: [
          //   {
          //     label: '已兑换',
          //     value: 1
          //   },
          //   {
          //     label: '已核销',
          //     value: 2
          //   }
          // ],
          // filterMultiple: false,
          // filterMethod(value, row) {
          //   if (value === 1) {
          //     statusC = 'ASC'
          //     return row.status == '已兑换'
          //   } else if (value === 2) {
          //     statusC = 'DESC'
          //     return row.status == '已核销'
          //   }
          // }
        }, {
          title: '兑换来源',
          key: 'from'
        }, {
          title: '联系电话',
          key: 'tel',
        }],
        exchangeData: [],//兑换统计人员集合
        total: 0,
        page: 1,
        rows: 12,
        // modalPeople: [],//弹窗用的数据数组
        hexiaoPeople: [],//当前商品 未核销/未兑换 人员集合
        // ModalBtn: [],//核销弹窗底部按钮
        buluPeople: [],//补录人员
        hexiaoBtn: [{
          name: '取消',
          type: 'text',
          value: 'cancel',
          loading: false,
        }, {
          name: '取消兑换',
          type: 'primary',
          value: 'no',
          loading: false,
        }, {
          name: '核销',
          type: 'primary',
          value: 'ok',
          loading: false,
        }],
        buluBtn: [{
          name: '取消',
          type: 'text',
          value: 'cancel',
          loading: false,
        }, {
          name: '确定',
          type: 'primary',
          value: 'ok',
          loading: false,
        }],
        download0: false,//下载二维码的按钮
        download1: false,//下载海报的按钮
        showPage: true,
        order:'',//DESC，ASC
      }

    },
    methods: {
      clickDrop(name) {
        console.log('clickdrop')
        console.log(name)
      },
      tableChange(obj) {
        console.log(obj)
        if (obj.order == 'asc') {
          this.order = 'ASC'
        }else if (obj.order == 'desc') {
          this.order = 'DESC'
        }else {
          this.order = ''
        }
        this.getExchange()
      },
      /**鼠标悬浮 */
      imgHover() {
        this.isShowShadow = this.isImgFail ? false : true
      },
      /**鼠标移出 */
      imgOut() {
        this.isShowShadow = false
      },
      pageChange(num) {
        this.page = num
        this.getExchange()
      },
      getDetail() {
        var url = this.urlobj.getGoodDetail(this.id)
        this.$get(url).then(res => {
          var info = res.rows[0]
          this.good = {
            cover: info.coverPicUrl,
            title: info.title,//商品标题
            detail: info.remark,//商品详情
            laiyuan: info.source,//选择的来源
            source: info.scoreSource || 99,//积分来源
            score: info.score / 100,//商品积分
            num: info.quantity,//商品数量
            startDate: info.beginTime.slice(0,info.beginTime.length-5),//开始日期
            endDate: info.endTime.slice(0,info.endTime.length-5),//结束日期
            address: info.address,
            qrcode: info.goodsSourceList.map(item => {
              return {
                url: item.qrcodeUrl
              }
            })
          }

        })
      },
      noImg() {
        this.isImgFail = true
      },
      reloadImg() {
        this.isLoading = true
        this.isShowShadow = false
        var url = this.urlobj.getGoodQrcode(this.id)
        this.$post(url).then(res => {
          this.isLoading = false
          this.isImgFail = false
          this.good.qrcode = res.rows.map(item => {
            return {
              url: item.qrcodeUrl
            }
          })
        })
      },
      // 获取兑换统计人员集合
      getExchange() {
        var url = this.urlobj.getExchangePeople(this.id)
        this.$get(url, {
          pageSize: this.rows,
          pageNum: this.page,
          orderField:'status',
          orderSeq:this.order,
        }).then(res => {
          this.total = res.total
          this.exchangeData = res.rows.map(item => {
            return {
              name: item.name,
              status: item.status,
              from: item.appType,
              tel: item.phoneNO
            }
          })
        })
      },
      //获取当前商品 未核销 人员集合
      getGoodPeople(name = '') {
        var url = this.urlobj.getGoodPeople(this.id, 'uncomsume')
        this.$get(url, {
          name
        }).then(res => {
          this.hexiaoPeople = res.rows.map(item => {
            return {
              pic: item.headPicUrl,
              name: item.name,
              id: item.unionId,
              unionId: item.unionId
            }
          })
        })
      },
      //获取当前商品 未兑换 人员集合
      getBuluPeople(name = '') {
        var url = this.urlobj.getGoodPeople(this.id, 'unexchange')
        this.$get(url, {
          name
        }).then(res => {
          this.buluPeople = res.rows.map(item => {
            return {
              pic: item.headPicUrl,
              name: item.name,
              id: item.unionId,
              unionId: item.unionId
            }
          })
        })
      },
      //点击核销按钮
      showHexiao() {
        this.$refs.hexiaoModal.showModal = true
      },
      //点击补录按钮
      showBulu() {
        this.$refs.buluModal.showModal = true
      },
      searchHexiao(name) {
        this.getGoodPeople(name)
      },
      hexiaoSubmit(value, peopleList, index) {
        var isReturn = value == 'ok' ? 0 : 1//是否返还。1--返还，0--兑换
        var url = this.urlobj.goodEchange(this.id, isReturn)
        this.hexiaoBtn[index].loading = true
        this.$post(url,
          peopleList.map(item => {
            return {
              name: item.name,
              unionId: item.unionId
            }
          })
        ).then(res => {
          this.hexiaoBtn[index].loading = false
          var text = value == 'ok' ? '核销成功' : '取消成功'
          this.$Message.success(text)
          this.$refs.hexiaoModal.showModal = false
          this.getGoodPeople()
          this.page = 1
          this.showPage = false
          this.$nextTick(() => {
            this.showPage = true
          })
          this.getExchange()
        }).catch(e => {
          this.hexiaoBtn[index].loading = false
        })
      },
      searchBulu(name) {
        this.getBuluPeople(name)
      },
      buluSubmit(value, peopleList, index) {
        var url = this.urlobj.goodBulu(this.id)
        this.buluBtn[index].loading = true
        this.$post(url,
          peopleList.map(item => {
            return {
              name: item.name,
              unionId: item.unionId
            }
          })
        ).then(res => {
          this.buluBtn[index].loading = false
          this.$Message.success('补录成功')
          this.$refs.buluModal.showModal = false
          this.getBuluPeople()
          this.page = 1
          this.showPage = false
          this.$nextTick(() => {
            this.showPage = true
          })
          this.getExchange()
        }).catch(e => {
          this.buluBtn[index].loading = false
        })
      },
      //下载二维码或者海报
      //type 0 二维码 1海报
      downLoad(type) {
        var checkUrl = this.urlobj.checkDownload(this.id)
        this[`download${type}`] = true
        this.$get(checkUrl, {
          isPoster: type
        }).then(res => {
          this[`download${type}`] = false
          var url = this.urlobj.downGoodQrcode(this.id) + '?isPoster=' + type
          window.open(url)
        }).catch(e => {
          this[`download${type}`] = false
        })
      },
      exportPeople() {
        var url = this.urlobj.exportGoodPeople(this.id)
        window.open(url)
      }
    },
    mounted() {
      that = this
      this.id = this.$route.query.id
      this.getDetail()
      this.getExchange()
      this.getGoodPeople()
      this.getBuluPeople()
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    height: 100%;
  }

  .header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    line-height: 84px;
    position: relative;
    padding: 0 20px;
    .iconfont {
      color: #999;
      font-size: 24px;
    }
    .header {
      font-size: 25px;
      text-align: center;
    }
  }

  .detail-card {
    width: 520px;
    margin-right: 20px;
    font-size: 15px;
    color: #333;
    display: flex;
    flex-direction: column;
    /deep/ .ivu-card-body {
      flex: 1
    }
    .card-title {
      font-size: 16px;
      justify-content: space-between;
      height: 50px;
      align-items: center;
    }
    button {
      height: 30px;
      width: 80px;
      line-height: 13px;
    }
    /deep/ .ivu-card-head {
      padding: 0 16px;
    }
    .cover {
      width: 480px;
      height: 300px;
      display: block;
      margin: auto;
    }
    .detail-info {
      justify-content: space-around;
      .detail-title {
        text-align: center;
        word-wrap: break-word;
        word-break: break-all;
        color: #333;
        font-size: 20px;
      }
      .detail-num {
        text-align: center;
        font-size: 16px;
        color: #ff7b44;
        .num-title {
          margin-right: 15px;
        }
      }
      .detail-time {
        color: #999;
        text-align: center;
        .iconfont {
          margin-right: 7px;
        }
      }
      .detail-address {
        color: #999;
        text-align: center;
        .iconfont {
          margin-right: 10px;
        }
      }
      /* 二维码 */
      .codeBox {
        width: fit-content;
        margin: 0 auto;
        .sao {
          text-align: center;
          margin-bottom: 10px;
          color: #333;
          font-size: 16px;
        }
        .cobox {
          width: 135px;
          height: 135px;
          margin: 0 auto;
          position: relative;
          // display: inline-block;
          // margin-left: 20px;
        }
        .cobox img {
          width: 100%;
          height: 100%;
        }
        .cobox .imgerror {
          width: 100%;
          height: 100%;
          border: 1px solid #dddddd;
          border-radius: 2px;
          font-size: 14px;
          color: #67799d;
          align-items: center;
          justify-content: center;
        }
        .btn {
          width: 150px;
          height: 36px;
          border: 1px solid #ff7b43;
          text-align: center;
          line-height: 36px;
          border-radius: 4px;
          cursor: pointer;
          margin: 0 auto;
          font-size: 14px;
        }
        .btn1 {
          .btn;
          color: #ff7b43;
          margin-bottom: 10px;
        }
        .btn2 {
          .btn;
          color: #fff;
          background-color: #ff7b43;
        }
        .shadow {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }
      .detail-btn {
        margin: 0 auto;
        button {
          display: block;
          height: 35px;
          width: 130px;
          &:first-child {
            margin-bottom: 10px;
            color: #ff7b44;
            border-color: #ff7b44;
          }
        }
      }
    }
  }

  .exchange-card {
    font-size: 15px;
    color: #333;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    /deep/ .ivu-card-body {
      flex: 1
    }
    /deep/ .ivu-card-head {
      padding: 0 16px;
    }
    button {
      height: 30px;
      width: 80px;
      line-height: 13px;
      &:first-child {
        margin-right: 10px;
      }
    }
    .card-title {
      font-size: 16px;
      justify-content: space-between;
      height: 50px;
      align-items: center;
    }
    .page-wrapper {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .triangle {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-top: 22px solid #47ba53;
    border-right: 22px solid transparent;
    border-left: 22px solid #47ba53;
    border-bottom: 22px solid transparent;
    border-top-left-radius: 4px;
  }

  .triangle-info {
    position: absolute;
    top: 10px;
    left: -1px;
    color: #fff;
    font-size: 12px;
    transform: scale(0.8) rotate(-45deg);
  }
</style>
